export default {
  lpStaking: {
    minimumAmount: "最低質押：{amount} USDT",
    amountTooLow: "質押數量不能低於 {amount} USDT",
    minimumLoading: "正在取得起押金額",
    minimumFailed: "起押金額暫不可用，請重試",
    confirmationDelayed: "鏈上確認仍在處理中，可手動重新整理質押狀態，請勿重複支付",
    statusUnknown: "狀態暫不可用",
    refreshStaked: "重新整理質押狀態",
    paid: "質押成功",
    unpaid: "待支付",
    confirming: "等待鏈上確認",
    contractPending: "LP 合約待發布，暫不能質押",
    orderInvalid: "訂單資料異常，請先核對質押記錄",
    walletRequired: "請先連接錢包",
    wrongNetwork: "請切換至正確網路",
    accountChanged: "錢包帳戶已變更，請重新登入",
    signatureRejected: "已取消錢包操作",
    submitFailed: "提交失敗，請重試",
    retryHash: "重新提交交易 Hash",
    hashRetryHint: "交易已發送，請重試提交 Hash，不要重複支付",
    paymentUncertain: "交易狀態待核實，請先查看質押記錄，勿重複支付",
    orderNumber: "訂單編號",
    transactionHash: "交易 Hash",
    refreshRecords: "重新整理",
    retry: "重試",
    noRecords: "暫無記錄",
    recordsFailed: "取得記錄失敗，請重試",
    stakingIncome: "質押收益",
    loadMore: "載入更多",
    ordersPending: "質押記錄暫不可用",
    title: "LP質押",
    staked: "已質押 USDT",
    stakeUsdt: "質押 USDT",
    walletBalance: "錢包 USDT 餘額",
    refreshBalance: "重新整理錢包餘額",
    amount: "質押數量",
    amountPlaceholder: "請輸入質押數量",
    amountHint: "選擇快捷金額，或手動輸入",
    confirm: "確認質押",
    stakingPending: "質押功能待接入",
    dataPending: "資料待接入",
    unavailable: "暫不可用",
    balanceFailed: "取得錢包餘額失敗，請重試",
    amountRequired: "請輸入質押數量",
    amountInvalid: "請輸入大於 0 的有效金額",
    insufficient: "錢包 USDT 餘額不足",
    records: "我的質押記錄",
    ranking: "全網質押排行",
    earnings: "收益記錄",
    recordsDescription: "僅展示我的質押記錄",
    rankingDescription: "按錢包累計質押金額排序",
    rankingHint: "同一錢包多筆質押合併統計",
    earningsDescription: "查看每筆收益明細",
    back: "返回 LP質押",
    recordLinks: "記錄入口",
  },
  确认: "確認",
  取消: "取消",
  选择语言: "選擇語言",
  切换语言成功: "切換語言成功",
  首页: "首頁",
  采购: "報單",
  团队: "團隊",
  "交易进行中,请勿进行其他操作": "交易進行中,請勿進行其他操作",
  资金管理: "資金管理",
  资金明细: "資金明細",
  我的订单: "我的訂單",
  订单详情: "訂單詳情",
  没有更多了: "沒有更多了",
  加载中: "加載中",
  代币价格: "代幣價格",
  收益概览: "收益概覽",
  申购收益: "申購收益",
  分享收益: "分享收益",
  官方网站: "官方網站",
  官网: "官網",
  电报: "電報",
  推特: "推特",
  白皮书: "白皮書",
  申购金额: "申購金額",
  请输入入金金额: "請輸入入金金額",
  快捷申购: "快捷申購",
  申购比例: "申購比例",
  赠币数量: "贈幣數量",
  立即申购: "立即申購",
  更多: "更多",
  订单: "訂單",
  分红中: "分紅中",
  已完成: "已完成",
  累计分红: "累計分紅",
  申购信息: "申購信息",
  兑换数量: "兌換數量",
  赠币数量: "贈幣數量",
  开始时间: "開始時間",
  提现成功: "提現成功",
  确认: "確認",
  订单编号: "訂單編號",
  团队数据总览: "團隊數據總覽",
  我的推广链接: "我的推廣鏈接",
  复制: "複製",
  "分享此链接邀请好友加入团队，获取推广奖励":
    "分享此鏈接邀請好友加入團隊，獲取推廣獎勵",
  团队业绩: "團隊業績",
  当前等级: "當前等級",
  今日收益: "今日收益",
  申购收益: "申購收益",
  分享收益: "分享收益",
  团队用户: "團隊用戶",
  有效团队: "有效團隊",
  有效用户: "有效用戶",
  无效团队: "無效團隊",
  直推用户: "直推用戶",
  有效直推: "有效直推",
  无效直推: "無效直推",
  资产余额数据概览: "資產餘額數據概覽",
  提现: "提現",
  选中币种: "選中幣種",
  请输入入金金额: "請輸入入金金額",
  提现数量: "提現數量",
  确认提现: "確認提現",
  资金明细: "資金明細",
  分红收入: "分紅收入",
  直推奖励: "直推獎勵",
  团队奖励: "團隊獎勵",
  申购金额: "申購金額",
  兑换数量: "兌換數量",
  赠币数量: "贈幣數量",
  开始时间: "開始時間",
  立即申购: "立即申購",
  确认: "確認",
  全部: "全部",
  收入: "收入",
  支出: "支出",
  请输入正确的金额: "請輸入正確的金額",
  申购成功: "申購成功",
  申购失败: "申購失敗",
  提现失败: "提現失敗",
  提现信息: "提現信息",
  提现币种: "提現幣種",
  提现数量: "提現數量",
  请选择币种: "請選擇幣種",
  钱包余额不足: "錢包餘額不足",
  余额不足: "餘額不足",
  提现手续费: "提現手續費",
  间推奖励: "間推獎勵",
  团队奖励: "團隊獎勵",
  提现失败退还: "提現失敗退還",
  ido申购: "ido申購",
  ido申购赠送: "ido申購贈送",
  链式去中心化全球点火网络: "鏈式去中心化全球點火網絡",
  协议永生: "協議永生",
  智能涌现: "智能湧現",
  财富觉醒: "財富覺醒",
  立即进入: "立即進入",
  大区累计业绩: "大區累計業績",
  小区累计业绩: "小區累計業績",
  复制成功: "複製成功",
  复制失败: "複製失敗",
  暂无数据: "暫無數據",
  当DeFi遇上自主型DAO: "當DeFi遇上自主型DAO",
  历史最高: "歷史最高",
  历史最低: "歷史最低",
  当前价格: "當前價格",
  采购累计收益: "報單累計收益",
  团队累计收益: "團隊累計收益",
  采购金额: "報單金額",
  快捷采购: "快捷報單",
  请输入采购金额: "請輸入報單金額",
  采购比例: "報單比例",
  采购信息: "報單信息",
  进行中: "進行中",
  已完成: "已完成",
  累计收益: "累計收益",
  立即采购: "立即報單",
  请输入提现数量: "請輸入提現數量",
  提现确认: "提現確認",
  "本次提现的链上Gas费需由您自行承担，点击确定将执行提现流程，届时提取的余额会被优先扣除":
    "本次提現的鏈上Gas費需由您自行承擔，點擊確定將執行提現流程，屆時提取的餘額會被優先扣除",
  "操作后无法撤销，请谨慎认购": "操作後無法撤銷，請謹慎認購",
  我再想想: "我再想想",
  确认提现: "確認提現",
  余额不足: "餘額不足",
  直推奖励: "直推獎勵",
  团队奖励: "團隊獎勵",
  提现失败退还: "提現失敗退還",
  平级收益: "平級收益",
  每日释放: "每日釋放",
  提现TDL: "提現TDL",
  采购失败: "報單失敗",
  绑定邀请人: "綁定邀請人",
  采购成功: "報單成功",
  提现比例: "提現比例",
  入金支付说明: "入金支付說明",
  "您的实际支付由两部分组成，根据当前支付比例计算":
    "您的實際支付由兩部分組成，根據當前支付比例計算",
  支付TDL数量: "支付TDL數量",
  入金数量: "入金數量",
  TDL支付比例: "TDL支付比例",
  "注：支付比例由平台设定，可能随时调整":
    "註：支付比例由平台設定，可能隨時調整",
  我知道了: "我知道了",
  支付USDT数量: "支付USDT數量",
  USDT支付比例: "USDT支付比例",
  TDL实时价格: "TDL實時價格",
  请先连接TCC链: "請先連接TCC鏈",
  收益中: "收益中",
  世界华人的GDT: "世界华人的GDT",
  当Defi遇上自主型DAO: "当Defi遇上自主型DAO",
  提现GGC: "提现GGC",
  支付GGC数量: "支付GGC數量",
  GGC支付比例: "GGC支付比例",
  GGC实时价格: "GGC實時價格",
  兑换: "兌換",
  兑换比例: "兌換比例",
  兑换数量: "兌換數量",
  确认兑换: "確認兌換",
  请输入兑换数量: "請輸入兌換數量",
  兑换失败退还: "兌換失敗退還",
  兑换GGC: "兌換GGC",
  请输入采购方式: "請輸入報單方式",
  余额采购: "餘額報單",
  钱包采购: "錢包報單",
  资产余额: "資產餘額",
  资产明细: "資產明細",
  余额支付: "餘額支付",
  商城划转: "商城划轉",
  商城划转GGC: "商城划轉GGC",
  采购收益GGC: "報單收益GGC",
  采购方式: "報單方式",
  采购数量: "報單數量",
  链上全球购余额: "鏈上全球购餘額",
  全球购划转USDT: "全球购划轉USDT",
  全球购划转GGC: "全球购划轉GGC",
  生态合成: "生態合成",
  合成数量: "合成數量",
  合成方式: "合成方式",
  快捷合成: "快捷合成",
  合成比例: "合成比例",
  点击更多更多订单里面还有: "點擊更多更多訂單裡面還有",
  合成信息: "合成資訊",
  合成累计收益: "合成累計收益",
  收益统计: "收益統計",
  请输入合成数量: "請輸入合成數量",
  请输入合成方式: "請輸入合成方式",
  合成说明: "合成說明",
  "50％GGC": "50％GGC",
  "50％GGC价值U": "50％GGC價值U",
  GDT链GGC余额: "GDT鏈GGC餘額",
  GDT链USDT余额: "GDT鏈USDT餘額",
  支付GGC: "支付GGC",
  支付USDT: "支付USDT",
  获取钱包余额失败: "獲取錢包餘額失敗",
  全球购余额: "全球購餘額",
  钱包余额: "錢包餘額",
  全球购划转余额: "全球購劃轉餘額",
  采购奖励USDT: "報單獎勵USDT",
  贸易额度奖励GGC: "贸易额度獎勵GGC",
  可变现GGC2数量: "可變現GGC2數量",
  警告: "警告",
  "需配置与GGC价值相等的U合成 , 按双倍GGC数":
    "需配置與GGC價值相等的U合成 , 按雙倍GGC數",
  量释放: "量釋放",
  "需配置与GGC价值相等的U合成 , 按双倍GGC数量释放":
    "需配置與GGC價值相等的U合成 , 按雙倍GGC數釋放",
  该项业务不为中国用户提供任何服务: "該項業務不為中國用戶提供任何服務",
  "返回到钱包主页面,即可查阅到生态合成所支付的各项明细(包含：GGC、GDT、USDT)":
    "返回到錢包主頁面,即可查阅到生態合成所支付的各项明細(包含：GGC、GDT、USDT)",
};
